module.exports = __webpack_public_path__ + "static/media/marker-red-small.54bcc99a.png";